import { estiloColores } from "./colores";

export const estiloBotones = {
  Siguiente: {
    backgroundColor: estiloColores.PrincipalColorFondo,
    color: estiloColores.PrincipalColorTexto,
  },

  ActivarCuenta: {
    backgroundColor: estiloColores.PrincipalColorFondo,
    color: estiloColores.PrincipalColorTexto,
  },

  GuardarCambios: {
    backgroundColor: estiloColores.PrincipalColorFondo,
    color: estiloColores.PrincipalColorTexto,
  },

  CrearCuenta: {
    backgroundColor: estiloColores.PrincipalColorFondo,
    color: estiloColores.PrincipalColorTexto,
  },

  Ingresar: {
    backgroundColor: estiloColores.PrincipalColorFondo,
    color: estiloColores.PrincipalColorTexto,
  },

  Cerrar: {
    backgroundColor: estiloColores.SecundarioColorFondo,
    color: estiloColores.SecundarioColorTexto,
  },

  Nuevo: {
    backgroundColor: estiloColores.Azul,
    color: estiloColores.Blanco,
  },

  Aceptar: {
    backgroundColor: estiloColores.PrincipalColorFondo,
    color: estiloColores.PrincipalColorTexto,
    borderRadius: "10px",
  },

  Cancelar: {
    backgroundColor: estiloColores.Celeste,
    color: estiloColores.PrincipalColorTexto,
    borderRadius: "10px",
  },

  InstalarAplicacion: {
    backgroundColor: estiloColores.SecundarioColorFondo,
    color: estiloColores.SecundarioColorTexto,
  },
};
